<ng-select
  class="autocomplete-vocabulary"
  [ngModel]="value"
  [disabled]="isDisabled$ | async"
  [bindValue]="bindValue"
  [bindLabel]="bindLabel"
  [items]="(terms$ | async)?.data"
  [addTag]="openVocabulary"
  [addTagText]="'Nuovo termine'"
  [dropdownPosition]="'bottom'"
  [placeholder]="placeholder | translate"
  (focus)="onFocusHandler()"
  (scroll)="onScrollHandler()"
  (change)="changeValueHandler($event)">
</ng-select>
